import { DateTime, Duration } from "luxon";
import { z } from "zod";
const serializedDateRangeSchema = z.object({
  length_days: z.number().positive(),
  end: z.iso.datetime().nullable()
});
function serializeDateRange(dateRange) {
  return {
    length_days: Math.round(dateRange.length.as("days")),
    end: dateRange.end ? dateRange.end.toUTC().toISO() : null
  };
}
function deserializeDateRange(serialized) {
  const length = Duration.fromObject({ days: serialized.length_days });
  if (!length.isValid) {
    return void 0;
  }
  let end;
  if (serialized.end !== null) {
    const parsed = DateTime.fromISO(serialized.end);
    if (!parsed.isValid) {
      return void 0;
    }
    end = parsed;
  }
  return { length, end };
}
const DEFAULT_DATE_RANGE_DAYS = 14;
const defaultDateRange = Object.freeze({
  length: Duration.fromObject({ days: DEFAULT_DATE_RANGE_DAYS }),
  end: void 0
});
function checkIsDateRangeEqual(a, b) {
  if (a === b) {
    return true;
  }
  if (a === void 0 || b === void 0) {
    return false;
  }
  return a.length.equals(b.length) && a.end?.toMillis() === b.end?.toMillis();
}
function ceilToStartOfDay(dateTime) {
  const startOfDay = dateTime.startOf("day");
  return +dateTime === +startOfDay ? startOfDay : startOfDay.plus({ days: 1 });
}
function endOfContainingDay(dateTime) {
  return ceilToStartOfDay(dateTime).minus({ milliseconds: 1 });
}
function resolveDateRangeToUtcDayIsoRange(range, now) {
  if (range.end === void 0) {
    const to2 = now.toUTC().startOf("day");
    return {
      from: to2.minus(range.length).startOf("day").toISO(),
      to: to2.toISO()
    };
  }
  const fromCalendarDate = ceilToStartOfDay(range.end.minus(range.length));
  const toCalendarDate = ceilToStartOfDay(range.end);
  const from = fromCalendarDate.setZone("utc", {
    keepLocalTime: true
  });
  const to = toCalendarDate.setZone("utc", {
    keepLocalTime: true
  });
  return {
    from: from.toISO(),
    to: to.toISO()
  };
}
export {
  DEFAULT_DATE_RANGE_DAYS,
  ceilToStartOfDay,
  checkIsDateRangeEqual,
  defaultDateRange,
  deserializeDateRange,
  endOfContainingDay,
  resolveDateRangeToUtcDayIsoRange,
  serializeDateRange,
  serializedDateRangeSchema
};
//# sourceMappingURL=dateRange.js.map
